import Device from "../../../devices/device";

/**
 * Fallback para dispositivos cuyo player nativo no expone el idioma de las pistas
 * de audio/subtítulos (ej. Hisense/Vidaa con SmoothStreaming devuelve language="und").
 *
 * Parsea el manifest SmoothStreaming (<StreamIndex Type="audio|text" Language="..."
 * Name="...">) y devuelve las pistas por orden, para poder mapearlas contra el
 * índice (track.id) que sí da el player nativo.
 */

const cache = { url: null, data: null };

/**
 * Obtiene la URL del manifest SmoothStreaming real.
 * En Hisense la src del player es el endpoint web-initiator con ?manifest=<encoded>.
 */
export const getMssManifestUrl = () => {
  try {
    const device = Device.getDevice();
    if (device.getPlatform() !== 'hisense') return null;
    const player = device.getPlayer();
    const src =
      (player && ((player.options && player.options.src) || player.src)) || '';
    const match = src.match(/[?&]manifest=([^&]+)/);
    if (match && match[1]) return decodeURIComponent(match[1]);
    return src || null;
  } catch (e) {
    console.log('[MSS-TRACKS] getMssManifestUrl error', e);
    return null;
  }
};

const parseXml = (xmlText) => {
  const audio = [];
  const subtitles = [];
  try {
    const doc = new DOMParser().parseFromString(xmlText, 'application/xml');
    const streamIndexes = Array.prototype.slice.call(
      doc.getElementsByTagName('StreamIndex')
    );
    streamIndexes.forEach((si) => {
      const type = (si.getAttribute('Type') || '').toLowerCase();
      const lang = si.getAttribute('Language') || '';
      const name = si.getAttribute('Name') || '';
      const subtype = (si.getAttribute('Subtype') || '').toUpperCase();
      if (type === 'audio') {
        audio.push({ index: audio.length, lang, name });
      } else if (type === 'text') {
        subtitles.push({ index: subtitles.length, lang, name, subtype });
      }
    });
  } catch (e) {
    console.log('[MSS-TRACKS] parseXml error', e);
  }
  return { audio, subtitles };
};

/**
 * @param {string} [manifestUrl] opcional; si no se pasa se resuelve con getMssManifestUrl()
 * @returns {Promise<{audio: Array, subtitles: Array}>}
 */
export const getMssManifestTracks = async (manifestUrl) => {
  if (Device.getDevice().getPlatform() !== 'hisense') return { audio: [], subtitles: [] };
  const url = manifestUrl || getMssManifestUrl();
  if (!url) return { audio: [], subtitles: [] };
  if (cache.url === url && cache.data) return cache.data;
  try {
    const withTimeout = (promise, ms) => new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => reject(new Error('timeout')), ms);
      promise.then(
        (value) => {
          clearTimeout(timeoutId);
          resolve(value);
        },
        (error) => {
          clearTimeout(timeoutId);
          reject(error);
        }
      );
    });
    const res = await withTimeout(fetch(url, { credentials: 'omit' }), 5000);
    const xmlText = await withTimeout(res.text(), 5000);
    const data = parseXml(xmlText);
    cache.url = url;
    cache.data = data;
    return data;
  } catch (e) {
    console.log('[MSS-TRACKS] fetch/parse error', e);
    return { audio: [], subtitles: [] };
  }
};

export const clearMssManifestTracksCache = () => {
  cache.url = null;
  cache.data = null;
};



// WEBPACK FOOTER //
// ./src/components/EventOptions/utils/mssManifestTracks.js